import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import Home from '../../containers/Home';
import NewProjectsTasksContainer from '../../containers/TasksContainer/NewProjectsTasksContainer';
import MobileHeader from '../../components/MobileHeader';
import dataModel from '../../models/DataModel';
import TasksAssignedCollection from '../../dao/collections/TasksAssignedCollection';
import '../MobileWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';
import { mobile_project_root } from '../../dao/ProjectsDAO';
import { attributes_task_root } from '../../dao/TasksDAO';

export class ProjectsTasksWrapper extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      isInitialized: false,
      defaultFilters: [
        {
          title: 'Task Status',
          initiallyExpanded: true,
          options: [
            { value: 'not_started', name: this.textMap.notStarted, type: 'statuses' },
            { value: 'in_progress', name: this.textMap.inProgress, type: 'statuses' },
            { value: 'pending_review', name: this.textMap.pendingReview, type: 'statuses' },
            { value: 'pending_approval', name: this.textMap.pendingApproval, type: 'statuses' },
            { value: 'completed', name: this.textMap.completed, type: 'statuses' },
          ],
        },
      ],
      appliedTaskFilters: [],
      myProjects: [],
      pending: 'pending',
      currentTaskCount: -1,
      totalTasks: 0,isFilterApplied: false,
    };

    this.perPage = Math.floor((window.innerHeight - 50) / 84);
    this.handleScroll = this.handleScroll.bind(this);
    this.fetchInProgress = false;
  }

  handleFilterChange(urlFilter, fromInitialize) {
    if (!this.tasksAssignedCollection && this.props.currentUser) {
      this.tasksAssignedCollection = TasksAssignedCollection.build(this.props.currentUser.id, this.props.currentCompany.id, urlFilter, false, 1, this.perPage, null, null);
    }
    if (this.tasksAssignedCollection) {
      if (this.tasksAssignedCollection.statusFilter != urlFilter) {
        this.tasksAssignedCollection.statusFilter = urlFilter;
        this.tasksAssignedCollection.reset();
      }
    }
    this.setState({ appliedTaskFilters: urlFilter, myProjects: [] });
    if (this.props.currentCompany) {
      this.setState({ pending: 'pending' });
      this.fetchData(this.props.currentCompany, urlFilter, fromInitialize ? false : true, true).then(() => {
        this.setState({ pending: '' });
      });
    }
  }

  componentDidMount() {
    const filter = this.props.match.params.filter;
    mobileBridge.initialize(this.props.history);
    if (filter) {
      let urlFilter;
      if(filter == 'in_review') {
        urlFilter = ['pending_review', 'pending_approval'];
      } 
      else if (filter == 'all') {
        urlFilter = [];
      }
      else if (filter && filter.includes(',')) {
        urlFilter = filter.split(',');
      } 
      else {
        urlFilter = [filter];
      }
      if (this.props.match.params.project_id) {
        this.setState({ project_id: this.props.match.params.project_id });
      }
      this.handleFilterChange(urlFilter, true);
    }

    // Done without ids because we need to pick up new assignments to current user
    dataModel.actionCableConnector.registerCallback(this.handleActionCableProjectUpdate, ['updateProject'], null, mobile_project_root); 
  }

  componentWillUnmount() {
    if (this.projectIds) {
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['deleteProject'], this.projectIds); 
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['deleteTask', 'updateTask'], this.taskIds); 
    }
    dataModel.actionCableConnector.unregisterCallback(this.handleActionCableProjectUpdate, ['updateProject']); 
  }

  handleActionCable(fetchedData, acData) {
    this.setState({ pending: 'pending' });
    this.fetchData(this.props.currentCompany, this.state.appliedTaskFilters, true, true).then(() => {
      this.setState({ pending: '' });
    });
  }

  handleActionCableProjectUpdate(fetchedData, acData) {
    // is it one I care about?
    if (fetchedData.users) {
      if (fetchedData.users.find(userId => { return userId == this.props.currentUser.id; })) {
        this.setState({ pending: 'pending' });
        this.fetchData(this.props.currentCompany, this.state.appliedTaskFilters, true, true).then(() => {
          this.setState({ pending: '' });
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.online != this.props.online)
    {
      this.tasksAssignedCollection.reset();
      this.fetchData(this.props.currentCompany, this.state.appliedTaskFilters).then(() => {
        this.setState({ pending: '' });
      });
    }
  }

  async fetchData(company, filters, fetchCurrent, fromActionCable) {
    
    // unregister action cable

    if (this.projectIds) {
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['deleteProject', 'updateProject'], this.projectIds); 
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['deleteTask', 'updateTask'], this.taskIds); 
    }

    company = company ? company : this.props.currentCompany;
    if (!this.tasksAssignedCollection) {
      this.tasksAssignedCollection = TasksAssignedCollection.build(this.props.currentUser.id, this.props.currentCompany.id, filters, false, 1, this.perPage, null, null);
    }
    else if (this.tasksAssignedCollection.statusFilter != filters){
      this.tasksAssignedCollection.statusFilter = filters;      
    }
    
    let fetchedTasks;
    if (fetchCurrent) {
      fetchedTasks = await this.tasksAssignedCollection.fetchCurrent(true, { clear: fromActionCable, recordDescriptor: attributes_task_root });
    } else {
      fetchedTasks = await this.tasksAssignedCollection.fetchNext(null, { clear: fromActionCable, recordDescriptor: attributes_task_root });
    }

    let myProjects = [];
    let projects = {};
    this.projectIds = [];
    this.taskIds = [];
    for (let task of fetchedTasks.tasks) {
      if (task && task.project_id) {
        this.taskIds.push(task.id);
        let taskProject = projects[task.project_id];
        if (!taskProject) {
          taskProject = await dataModel.projectsDAO.getProject(task.project_id, { recordDescriptor: mobile_project_root });
          if (taskProject) {
            myProjects.push(taskProject);
            this.projectIds.push(taskProject.id);
          }
          projects[taskProject.id] = taskProject;
          taskProject.tasks = [];
        }
        taskProject.tasks.push(task);
      }
    }
    dataModel.actionCableConnector.registerCallback(this.handleActionCable, ['deleteProject', 'updateProject'], this.projectIds, mobile_project_root); 
    dataModel.actionCableConnector.registerCallback(this.handleActionCable, ['deleteTask', 'updateTask'], this.taskIds, attributes_task_root); 

    this.sortProjectTasks(myProjects);

    await this.setState({ 
      myProjects, 
      isInitialized: true, 
      currentTaskCount: fetchedTasks.ids.length, 
      totalTasks: fetchedTasks.totalTasks, 
    });
  }

  sortProjectTasks(projects) {
    for (let project of projects) {
      project.tasks.sort((t1, t2) => t2.completion_criteria_counts && t2.completion_criteria_coounts && t2.completion_criteria_counts.rejected - t1.completion_criteria_counts.rejected);
    }
  }

  applyFilters = filterArray => {
    filterArray = filterArray.statuses ? filterArray.statuses : [];
    this.props.history.replace('/mobile/projects-tasks/' + filterArray.join());
    this.setState({ appliedTaskFilters: filterArray });
    this.handleFilterChange(filterArray);
  };

  handleClear = () => {
    this.applyFilters([]);
  }
  handleAppliedFilters(filters){
   
    this.state.isFilterApplied=true;
   //localStorage.setItem('perPage',localStorage.getItem(''))
  }

  async handleScroll(e) {
    const scrollContainer = e.target;
    if (Math.ceil(scrollContainer.scrollTop + scrollContainer.clientHeight) >= scrollContainer.scrollHeight && this.state.currentTaskCount < this.state.totalTasks && !this.fetchInProgress) {
      await this.setState({ pending: 'load-more' });
      this.fetchInProgress = true;
      const currentTaskCount = this.state.currentTaskCount;
      await this.fetchData(this.props.currentCompany, this.state.appliedTaskFilters);
      this.fetchInProgress = false;
      this.setState({ pending: '' });
      if (this.state.currentTaskCount != currentTaskCount && this.state.currentTaskCount != this.state.totalTasks){
        // scroll a little more
        return 60;
      }
      return 0;
    }
  }

  render() {
    let { appliedTaskFilters, defaultFilters, project_id } = this.state;
    let {
      currentUser,
      currentCompany,
      permissions,
      systemPopup,
    } = this.props;

    if (this.state.navPath) {
      this.props.history.push({ pathname: this.state.navPath });
    }

    if (!currentUser || !currentCompany || !permissions) {
      return <Home type={'projects'} message={'Awaiting Initialization'} />;
    }

    this.setWhiteLabels(currentCompany);
    
    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={'Tasks'}
          filterOptions={defaultFilters}
          applyFilters={this.applyFilters}
          appliedFilters={{ statuses: appliedTaskFilters }}
          rootPage={this.props.rootPage}
          hasFilters={true}
          handleClear={this.handleClear}
          handleAppliedFilters={this.handleAppliedFilters}
        />
        {systemPopup}
        <div 
          className="content-wrapper" 
        >
          <NewProjectsTasksContainer 
            appliedFilters={appliedTaskFilters} 
            myProjects={this.state.myProjects} 
            project_id={project_id} 
            pending={this.state.pending} 
            handleScroll={this.handleScroll}
          />
        </div>
      </div>
    );
  }
}

ProjectsTasksWrapper.defaultProps = {
  rootPage: false,
};

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    actionCableUpdate: state.main.actionCableUpdate,
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    systemPopup: state.main.systemPopup,
    online: state.main.online,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectsTasksWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/ProjectsTasksWrapper/index.js